import { createTheme } from '@mui/material';

declare module '@mui/material/styles' {
  interface Theme {
    sidebarWidth: number;
    sidebarMobileHeight: number;
    brand: string;
    footerHeight: number;
    mobileTopBarHeight: number;
    mobileFooterHeight: number;
    sidebarMobilePadding: number;
    participantBorderWidth: number;
    rightDrawerWidth: number;
    galleryViewBackgroundColor: string;
  }

  // allow configuration using `createTheme`
  interface ThemeOptions {
    sidebarWidth?: number;
    sidebarMobileHeight?: number;
    brand?: string;
    footerHeight?: number;
    mobileTopBarHeight?: number;
    mobileFooterHeight?: number;
    sidebarMobilePadding?: number;
    participantBorderWidth?: number;
    rightDrawerWidth?: number;
    galleryViewBackgroundColor?: string;
  }
}

const defaultTheme = createTheme();

export default createTheme({
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        '@global': {
          '@font-face': [
            {
              fontDisplay: 'swap',
              fontFamily: 'Inter',
              fontWeight: '100 400',
              src: `url(https://designsystem.brevo.com/designsystem/e89cb19905e7db5591b0.ttf) format("truetype")`,
            },
            {
              fontDisplay: 'swap',
              fontFamily: 'Inter',
              fontWeight: '500 600',
              src: `url(https://designsystem.brevo.com/designsystem/4d56bb21f2399db8ad48.ttf) format("truetype")`,
            },
            {
              fontDisplay: 'swap',
              fontFamily: 'Inter',
              fontWeight: '700 900',
              src: `url(https://designsystem.brevo.com/designsystem/88fa7ae373b07b41ecce.ttf) format("truetype")`,
            },
          ],
          'html, body, #root': {
            height: '100%',
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '5px',
          textTransform: 'none',
          color: 'rgb(40, 42, 43)',
          fontSize: '1rem',
          transition: defaultTheme.transitions.create(['background-color', 'box-shadow', 'border', 'color'], {
            duration: defaultTheme.transitions.duration.short,
          }),
        },
        text: {
          padding: '6px 14px',
        },
        contained: {
          boxShadow: 'none',
          '&:hover': {
            boxShadow: 'none',
          },
        },
        outlinedPrimary: {
          border: '2px solid #000',
          '&:hover': {
            border: '2px solid #000',
          },
        },
        startIcon: {
          marginRight: '6px',
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        body1: {
          color: 'rgb(40, 42, 43)',
          fontSize: '0.9rem',
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          fontSize: '0.9rem',
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        root: {
          padding: '0.85em',
        },
      },
    },
    MuiDialogActions: {
      styleOverrides: {
        root: {
          padding: '16px',
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          color: 'rgb(40, 42, 43)',
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: 'rgb(40, 42, 43)',
          fontSize: '1.1rem',
          marginBottom: '0.2em',
          fontWeight: 500,
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        notchedOutline: {
          borderColor: 'rgb(136, 140, 142)',
        },
      },
    },
  },
  typography: {
    fontFamily: 'Inter,Helvetica Neue,sans-serif',
  },
  palette: {
    primary: {
      main: '#000',
    },
  },
  brand: '#00c6ff',
  footerHeight: 72,
  mobileFooterHeight: 56,
  sidebarWidth: 300,
  sidebarMobileHeight: 90,
  sidebarMobilePadding: 8,
  participantBorderWidth: 2,
  mobileTopBarHeight: 52,
  rightDrawerWidth: 400,
  galleryViewBackgroundColor: 'var(--sib-color_primary-hover)',
});
